import axios from 'axios';
// Public bearer requests must not inherit account headers, auth retries or caches.
const client = axios.create({baseURL: `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/api/public/estimate-acceptance`, timeout: 30000});
export const publicEstimateAcceptance = {
  get: (token, signal) => client.post('/view', {token}, {signal}),
  pdf: async (token, signal) => {
    try { return await client.post('/pdf', {token}, {responseType:'blob', signal}); }
    catch (error) {
      // Axios also returns JSON error responses as Blob for PDF requests.
      const data = error?.response?.data;
      if (data instanceof Blob && data.type.includes('json')) {
        try { error.response.data = JSON.parse(await data.text()); } catch { /* keep original error */ }
      }
      throw error;
    }
  },
  accept: (token, offer, names) => client.post('/accept', {token, pdf_sha256:offer.pdf_sha256, statement_version:offer.statement_version, confirmed:true, first_name:names.first_name.trim(), last_name:names.last_name.trim()}),
};
